import SurveyEditor from "../../../components/survey/SurveyEditor.vue";
import moment from "moment";
import Chartkick from "vue-chartkick";
import Loader from "@/components/loader/Loader.vue";
import {ResidentStatus} from "@/enums/ResidentStatus";
import {FamilyHubAppStatus} from "@/enums/FamilyHubAppStatus";
import firebase from "firebase/app";
import {serializer} from "@/api/shared/serializer";
import { DEFAULT_AVATAR_WHITE_200x200 } from "@/consts/default-avatar";
import {getRegionName} from "@/utils/functionsRegion";
import {MailingTypes} from "@/enums/MailingTypes";
import {FamilyHubUserStatus} from "@/enums/FamilyHubUserStatus";

Chartkick.options = {
    colors: ["#99ccff", "#99ccff"]
};

export default {
    name: "SurveyView",
    components: {
        Loader,
        SurveyEditor
    },
    data() {
        return {
            loading: true,
            loadingSaveTemplate: false,
            tab: null,
            e1: 3,
            audienceResidents: true,
            audienceFamily: false,
            audienceTriggered: false,
            audienceEmail: false,
            selectedMailingList: [],
            isAnonymizeSurvey: false,
            isPreliminaryQuestions: false,
            questions: [],
            isSaved: false,
            isMailingListDisabled: false,
            noAvatar: DEFAULT_AVATAR_WHITE_200x200,
            logoError: null,
            headersForResidents: [
                {
                    sortable: false,
                    width: 70,
                    value: 'imageUrl',
                },
                {
                    text: this.$t('GeneralTranslations.Name'),
                    sortable: false,
                    value: 'name',
                },
            ],
            headersForFamilyMembers: [
                {
                    sortable: false,
                    width: 70,
                    value: 'imageUrl',
                },
                {
                    text: this.$t('SurveyView.FamilyMemberName'),
                    sortable: false,
                    value: 'name',
                    width: 200,
                },
                {
                    text: this.$t('SurveyView.Resident'),
                    sortable: false,
                    value: 'residents',
                    width: 200,
                }
            ],
            headersForEmail: [
                {
                    sortable: false,
                    width: 70,
                    value: 'imageUrl',
                },
                {
                    sortable: false,
                    value: 'name',
                    width: 200,
                }
            ],
            jsonFieldsForResidents: {
                "Name": "name",
            },
            jsonFieldsForFamilyMembers: {
                "Name": "name",
                "Resident": "residents",
            },
            jsonFieldsForEmail: {
                "Name": "name",
            },
            isSurveyModified: false,
            isDisabledSave: true,
            hasErrors: false
        };
    },
    filters: {
        overflowEllipsis(value) {
            if (value.length > 30) {
                return value.slice(0, 30) + "..."
            } else {
                return value;
            }
        }
    },
    computed: {
        results: function () {
            const json = this.$store.state.surveyModule.currentSurveyResults;
            const resu = {};
            if (json != null) {
                json.forEach(function (res) {
                    for (const key in res.surveyResult) {
                        const question = resu[key] ?? {};
                        question[res.surveyResult[key]] =
                            (question[res.surveyResult[key]] ?? 0) + 1;
                        resu[key] = question;
                    }
                });
            }

            const getSelOption = this.getSelectedOption;
            Object.keys(resu).forEach(function (qtnKey) {
                const qtn = resu[qtnKey];
                Object.keys(qtn).forEach(function (anskey) {
                    const properQName = getSelOption(qtnKey, anskey);
                    if (properQName != anskey) {
                        if (properQName != null) {
                            qtn[properQName] = qtn[anskey];
                            delete qtn[anskey];
                        }
                    }
                });
            });
            console.log('results', resu);

            return resu;
        },
        resultsByResidents() {
            this.getHeaderBySurvey(this.residents, "Residents");
            return this.getResultBySurvey(this.residents);
        },
        resultsByFamilyMembers() {
            this.getHeaderBySurvey(this.familyMembers, "Family");
            return this.getResultBySurvey(this.familyMembers);
        },
        resultsByEmail() {
            const users = [...this.residents, ...this.familyMembers, ...this.facilityUsers];
            this.getHeaderBySurvey(users, "Email");
            return this.getResultBySurvey(users, "Email");
        },
        facility() {
            return this.$store.state.facilityModule.selectedFacility
        },
        facilityUsers()  {
            return this.$store.state.facilityModule.selectedFacilityUsers
        },
        user() {
            return this.$store.state.authModule.user;
        },
        survey() {
            return this.$store.state.surveyModule.currentSurvey
        },
        surveyTemplate() {
            return JSON.parse(this.survey.template);
        },
        surveyEmailTemplate() {
           return this.$store.state.facilityModule.surveyTemplates.filter(x => x.isEnabled)[0];
        },
        residents() {
            return this.$store.state.residentModule.residentsShortData
        },
        familyMembers() {
            return this.$store.state.residentModule.familyMembers;
        },
        surveyResults() {
            return this.$store.state.surveyModule.currentSurveyResults
        },
        ResidentCount() {
            return this.$store.state.residentModule.residentsShortData.length
        },
        isPublished() {
            return this.survey.status === "Published" ? 3 : 1;
        },
        enableTabs() {
            return (this.isSaved && (this.audienceResidents || this.audienceFamily || this.audienceTriggered || this.audienceEmail)) || this.survey.status == 'Published' || (this.survey.status == 'New' && (this.audienceResidents || this.audienceFamily || this.audienceTriggered || this.audienceEmail));
        },
        enableButton() {
            return (
              (this.audienceResidents || this.audienceFamily || this.audienceTriggered) && !this.audienceEmail ||
              (this.audienceEmail && this.selectedMailingList?.length > 0 && !this.isMailingListDisabled)
            );
        },
        audiences() {
            const arr = [];

            if(this.survey.audienceResidents) {
                arr.push("Residents")
            }
            if(this.survey.audienceFamily) {
                arr.push("Family Members")
            }
            if(this.survey.audienceTriggered) {
                arr.push("Triggered Survey")
            }
            if(this.survey.audienceEmail) {
                arr.push("Email")
            }

            return arr.join(', ');
        },
        completedList() {
            let number = 0;

            if(this.survey.audienceResidents) {
                number += this.residents.filter((r)=>r?.status === ResidentStatus.ActiveResident).length
            }

            if(this.survey.audienceFamily) {
                number += this.familyMembers.filter((r)=>r?.appStatus === FamilyHubAppStatus.Activated).length
            }

            if(this.survey.audienceEmail && this.selectedMailingList?.length) {
                this.selectedMailingList.forEach(id => {
                    const list = this.mailingList.find(x => x.id === id);
                    if(list) {
                        const count = this.checkMailingType(list);
                        number += count;
                    }
                })
            }

            return number;
        },
        unsavedSurvey() {
            return this.$store.state.surveyModule.currentSurveyUnsavedChangesSurveyTemplate;
        },
        isCompleted() {
            return this.surveyResults?.length || 0;
        },
        mailingList() {
            return this.$store.state.facilityModule.facilityMailingLists.filter(x => x.type !== MailingTypes.Custom);
        },
        wings() {
            return this.$store.state.eventLocationModule.eventWings;
        },
        wingsIds() {
            return this.wings.map((wing: any) => wing.id);
        },
        careLevels() {
            return this.$store.state.careLevelsModule.careLevels;
        },
        careLevelsIds() {
            return this.$store.state.careLevelsModule.careLevels.map((x) => x.id);
        },
        careLevelsWingsIds(){
            return this.wings.filter(wing => this.careLevelsIds?.includes(wing?.careLevelId)).map((wing) => wing.id)
        },
        familyMembersWithWings(){
            return this.residents.filter((resident: any) =>  resident.status === ResidentStatus.ActiveResident && resident?.familyHubUsersIds?.length > 0 && this.wingsIds.includes(resident.wingId))
              .map((resident: any) =>
                this.familyMembers.filter((familyMember: any) => resident?.familyHubUsersIds?.includes(familyMember.id))
                  .map((user: any) => ({
                      ...user,
                      wingId: resident.wingId,
                      wingName: resident.wingName })
                  ))
              .flat()
              .reduce((unique: any[], user: any) => { if (!unique.some((u) => u.id === user.id)) { unique.push(user) } return unique }, []);
        },
        familyMembersPerLevelOfCare(){
            return this.residents.filter((resident: any) =>  resident.status === ResidentStatus.ActiveResident && resident?.familyHubUsersIds?.length > 0 && this.careLevelsWingsIds?.includes(resident.wingId))
              .map((resident: any) =>
                this.familyMembers.filter((familyMember: any) => resident?.familyHubUsersIds?.includes(familyMember.id))
                  .map((user: any) => ({
                      ...user,
                      careLevelIds: this.careLevels.filter((careLevel: any) => careLevel.wingsIds.includes(resident.wingId)).map((careLevel: any) => careLevel.id),})
                  ))
              .flat()
              .reduce((unique: any[], user: any) => { if (!unique.some((u) => u.id === user.id)) { unique.push(user) } return unique }, []);
        },
    },

    async created(){
        await this.$store.dispatch("getSurvey", { id: this.$route.params.id, isRoute: false });
        await this.$store.dispatch("getFamilyMembers");
        await this.$store.dispatch("getOrgUsers", this.user.orgId);
        await this.$store.dispatch("getFacilityMailingLists");
        await this.$store.dispatch("getFacilityEmailSurveyTemplates");
        await this.$store.dispatch("getEventWings");
        await this.$store.dispatch("getCareLevels");
        this.loading = false;

        if(this.survey) {
            this.checkSurveyAudience();
            this.e1 = parseInt(this.isPublished);
        }
        this.initTooltips();
    },

    watch: {
        unsavedSurvey(newValue, oldValue) {
            if(newValue !== oldValue && this.isSurveyModified) {
                setTimeout(() => {
                    this.isDisabledSave = false
                }, 500)
            }
        },
        audienceEmail(newValue) {
            if(!newValue) {
                this.selectedMailingList = [];
            }
            this.checkSurveyTemplate()
        },
        e1(newValue) {
            if(newValue === "1") {
                this.checkSurveyAudience()
                this.$forceUpdate()
            }
        }
    },

    methods: {
        routeToSurveysList() {
            this.$router.push("/surveys");
        },
        isTextBasedQuestion(question) {
            const surveyTemplate = JSON.parse(this.survey.template);

            if(!surveyTemplate?.pages) return false

            const foundQuestion = surveyTemplate.pages[0].elements.filter(function (
                qName
            ) {
                return qName.name == question;
            });

            if (foundQuestion == null) return true;
            if ( foundQuestion.length  < 1) return true;
            if (foundQuestion[0].type  === "comment") return true;

            return false;
        },
        getTitleFromQuestionName(question) {
            const surveyTemplate = JSON.parse(this.survey.template);

            if(!surveyTemplate?.pages) return ''

            const foundQuestion = surveyTemplate.pages[0].elements.filter(function (
                qName
            ) {
                return qName.name == question;
            });
            if (foundQuestion[0] == null) {
                return "NA";
            }
            return foundQuestion[0].title ?? question;
        },
        getSelectedOption(question, option) {
            const surveyTemplate = JSON.parse(this.survey.template);

            if(!surveyTemplate?.pages) return null

            const foundQuestion = surveyTemplate.pages[0].elements.filter(function (
                qName
            ) {
                return qName.name == question;
            });

            const foundQ = foundQuestion[0];
            if (foundQ == null) {
                return "NA";
            }
            if (foundQ.type == "boolean")
                return foundQ[option] == null ? option : foundQ[option];

            if (foundQ.type == "radiogroup" || foundQ.type == "checkbox") {
                const ans =
                    foundQ.choices.find((choice) => choice.value == option)?.text ??
                    option;
                return ans;
            }

            return null;
        },
        getCompletionTimeline(surveyResults) {
            const types = surveyResults.reduce(function (totals, surveyResult) {
                const date = moment(surveyResult.submittedDateTime)
                    .startOf("day")
                    .format("LL");
                !totals[date] ? (totals[date] = 1) : (totals[date] = totals[date] + 1);
                return totals;
            }, {});

            const sortedKeys = Object.keys(types).sort((a: any, b: any) => moment(a).diff(moment(b)));

            const sortedTypes = {};
            for (const key of sortedKeys) {
                sortedTypes[key] = types[key];
            }

            return sortedTypes;
        },
        async saveSurvey(key: string, tabIndex: number) {
                let isReadyForChange = true;
                this.loadingSaveTemplate = true;
                
            if(key === 'surveyBuilder') {
                await firebase
                  .firestore()
                  .collection("surveyResults")
                  .where("facilityId", "==", this.facility.id)
                  .where("surveyId", "==", this.survey.id)
                  .get()
                  .then(async (querySnapshot) => {
                      const data = serializer.querySnapshotToDocuments(querySnapshot);
                      if(data && data.length) {
                          isReadyForChange = false;
                      }
                  });
            }

            if(isReadyForChange) {
                await this.$store.dispatch("updateSurvey", {
                    id: this.survey.id,
                    audienceResidents: this.audienceResidents,
                    audienceFamily: this.audienceFamily,
                    audienceTriggered: this.audienceTriggered,
                    audienceEmail: this.audienceEmail,
                    selectedMailingList: this.selectedMailingList,
                    isAnonymizeSurvey: this.isAnonymizeSurvey,
                    isPreliminaryQuestions: this.isPreliminaryQuestions
                });
            } else {
                this.$toast.open({
                    type: "error",
                    message: this.$t('SurveyView.ThisSurveyHasAlreadyBeenOpened'),
                })
            }

            await this.$store.dispatch("getSurvey", { id: this.survey.id, isRoute: false });

            this.isSaved = true;
            this.isDisabledSave = true;
            this.loadingSaveTemplate = false;
            this.e1 = tabIndex;
        },
        archiveSurvey() {
            this.$store.dispatch("archiveSurvey", {
                id: this.survey.id,
                isRoute: false,
            });
            this.$router.push("/surveys/");
        },
        publishSurvey() {
            if(!this.surveyEmailTemplate || !this.surveyEmailTemplate?.html?.length){
                return
            }

            this.$store.dispatch("publishSurvey", { id: this.survey.id });

            firebase.app().functions(getRegionName())
              .httpsCallable("emails-sendEmailTemplate")({
                  emailTemplateId: this.surveyEmailTemplate.id,
                  templateData: null,
                  mailingListIds: this.selectedMailingList,
                  isSendDisabledEmailTemplate: true,
                  isAutomationTrigger: true,
                  sendOptions: {
                      additionalData: {
                          surveyId: this.survey.id,
                          surveyName: this.survey.name,
                          forceSend: true
                      }
                  }
              })
              .then(() => {
                  console.log("SUCCESS")
              }).catch((err) => {
                  console.log("ERROR ", err.message)
              })
        },
        getResultBySurvey(list, type?) {
            const currentSurveyResults = this.$store.state.surveyModule.currentSurveyResults;
            const surveyResults = currentSurveyResults.filter(x => type && type === "Email" ? x?.isCompletedByEmail : !x?.isCompletedByEmail);

            const result = [];

            surveyResults.forEach((res: any) => {
                const person = list.find(x => x.id === res.r);

                if(person && res.isCompleted) {
                    if(!result.find(x => x.id === person.id)) {
                        let obj = {
                            id: person.id,
                            imageUrl: res?.isAnonymizeSurveyResult ? this.noAvatar : person.imageUrl,
                            name: res?.isAnonymizeSurveyResult ? 'Anonymous' : person.name,
                            residents: this.getResidentsFamilyMember(res, person),
                        }

                        if(this.surveyTemplate) {
                            if(this.surveyTemplate?.pages && this.surveyTemplate?.pages.length) {
                                Object.keys(res.surveyResult).forEach((key) => {
                                    this.surveyTemplate.pages.forEach((page) => {
                                        const element = page.elements.find(item => item.name === key);
                                        const prop = element?.title ? element?.title : key;
                                        const keyAnswer = res.surveyResult[key];
                                        const choicesOrigin = element?.choices;
                                        let answer = "";
                                        let index = 0;

                                        if(!Array.isArray(keyAnswer) && choicesOrigin) {
                                            answer = choicesOrigin.find(x => x.value === keyAnswer)?.text;

                                            if(choicesOrigin.find(x => x.value === keyAnswer)) {
                                                index = choicesOrigin.findIndex(x => x.value === keyAnswer) + 1;
                                            } else {
                                                const keyAnswerString = String(keyAnswer);
                                                index = choicesOrigin.findIndex(x => x === keyAnswerString) + 1;
                                            }
                                        }

                                        if(Array.isArray(keyAnswer) && choicesOrigin) {
                                            let choices = "";
                                            keyAnswer.forEach(item => {
                                                const choice = choicesOrigin.find(x => x.value === item) ?? choicesOrigin.find(x => x === item);
                                                let indexLocal;

                                                if(choicesOrigin.find(x => x.value === item)) {
                                                    indexLocal = choicesOrigin.findIndex(x => x.value === item) + 1;
                                                } else {
                                                    const keyAnswerString = String(item);
                                                    indexLocal = choicesOrigin.findIndex(x => x === keyAnswerString) + 1;
                                                }

                                                if(choice) {
                                                    if(choices) {
                                                        choices = `${choices}, ${indexLocal} - ${choice?.text ?? choice}`;
                                                    } else {
                                                        choices = `${indexLocal} - ${choice?.text ?? choice}`;
                                                    }
                                                }
                                            });

                                            answer = choices;
                                        }


                                        if(element) {
                                            const localAnswer = answer ? answer : keyAnswer;
                                            const localIndex = index ? `${index} - ` : '';
                                            obj[prop] = `${localIndex} ${localAnswer ?? ''}`;
                                        }
                                    });
                                });
                            } else if(this.surveyTemplate?.elements && this.surveyTemplate?.elements.length) {
                                Object.keys(res.surveyResult).forEach((key) => {
                                    this.surveyTemplate.elements.forEach((elem) => {
                                        const name = elem.name;
                                        const title = elem.title;

                                        if(name === key) {
                                            if(title) {
                                                obj[title] = res.surveyResult[key];
                                            } else {
                                                obj[name] = res.surveyResult[key];
                                            }
                                        }
                                    });
                                });
                            }
                        } else {
                            obj = {...obj, ...res.surveyResult}
                        }

                        result.push(obj);
                    } else {
                        const index = result.findIndex(x => x.id === person.id);
                        const residentExist = result.find(x => x.id === person.id);

                        Object.entries(res.surveyResult).forEach(x => {
                            const prop = x[0];
                            const value = x[1];
                            if(Object.prototype.hasOwnProperty.call(residentExist, prop)) {
                                result[index][prop] = `${result[index][prop]}, ${value}`
                            } else {
                                result[index][prop] = value;
                            }
                        })
                    }
                }
            });

            return result;
        },
        getHeaderBySurvey(list, type) {
            const surveyResults = this.$store.state.surveyModule.currentSurveyResults;
            const questions = [];
            let countQuestions = 0;

            surveyResults.forEach((res: any) => {
                const person = list.find(x => x.id === res.r);

                if(person && res.isCompleted) {
                    const keys = Object.keys(res.surveyResult);

                    keys.forEach((item: any) => {
                        let question = null;
                        const key = item;

                        if(this.surveyTemplate) {
                            if(this.surveyTemplate?.pages && this.surveyTemplate?.pages.length) {
                                this.surveyTemplate.pages.forEach((page) => {
                                    const element = page.elements.find(item => item.name === key);
                                    if(element) {
                                        question = element?.title ? element.title : key;
                                    }
                                });

                                if(!questions.find(val => val.value === question) && question) {
                                    questions.push({
                                        text: `${this.$i18n.messages[this.$i18n.locale]['SurveyView.Question']} ${parseInt(key.match(/\d+/))}`,
                                        value: question,
                                        isQuestion: true,
                                        question: question,
                                        index: parseInt(key.match(/\d+/))
                                    })
                                }
                            } else if(this.surveyTemplate?.elements && this.surveyTemplate?.elements.length) {

                                this.surveyTemplate.elements.forEach((elem) => {
                                    const name = elem.name;
                                    const title = elem.title;

                                    if(name === key) {
                                        if(title) {
                                            question = title;
                                        } else {
                                            question = name;
                                        }
                                    }
                                });

                                if(!questions.find(val => val.value === question) && question) {
                                    questions.push({
                                        text: `${this.$i18n.messages[this.$i18n.locale]['SurveyView.Question']} ${ parseInt(key.match(/\d+/)) }`,
                                        value: question,
                                        isQuestion: true,
                                        question: question,
                                        index: parseInt(key.match(/\d+/))
                                    })
                                }
                            }
                        } else {
                            if(type === "Residents") {
                                if(!this.headersForResidents.find(val => val.value === key)) {
                                    countQuestions += 1;
                                    this.headersForResidents.push({
                                        text: `${this.$i18n.messages[this.$i18n.locale]['SurveyView.Question']} ${countQuestions}`,
                                        value: key,
                                        isQuestion: true
                                    })

                                    this.jsonFieldsForResidents[key] = key;
                                }
                            }

                            if(type === "Family") {
                                if(!this.headersForFamilyMembers.find(val => val.value === key)) {
                                    countQuestions += 1;
                                    this.headersForFamilyMembers.push({
                                        text: `${this.$i18n.messages[this.$i18n.locale]['SurveyView.Question']} ${countQuestions}`,
                                        value: key,
                                        isQuestion: true
                                    })

                                    this.jsonFieldsForFamilyMembers[key] = key;
                                }
                            }

                            if(type === "Email") {
                                if(!this.headersForEmail.find(val => val.value === key)) {
                                    countQuestions += 1;
                                    this.headersForEmail.push({
                                        text: `${this.$i18n.messages[this.$i18n.locale]['SurveyView.Question']} ${countQuestions}`,
                                        value: key,
                                        isQuestion: true
                                    })

                                    this.jsonFieldsForEmail[key] = key;
                                }
                            }
                        }
                    });
                }
            });

            if(questions.length) {

                if(type === "Residents" && !this.headersForResidents.find(val => val.value === questions[0].value)) {
                    const headers = questions.sort(function(a, b) {
                        return parseFloat(a.index) - parseFloat(b.index);
                    });
                    this.headersForResidents.push(...headers)

                    const jsonFieldsHeaders = {}
                    headers.forEach((x) => {
                        jsonFieldsHeaders[x.question] = x.question
                    });

                    this.jsonFieldsForResidents = {...this.jsonFieldsForResidents, ...jsonFieldsHeaders}
                }

                if(type === "Family" && !this.headersForFamilyMembers.find(val => val.value === questions[0].value)) {
                    const headers = questions.sort(function(a, b) {
                        return parseFloat(a.index) - parseFloat(b.index);
                    });
                    this.headersForFamilyMembers.push(...headers)

                    const jsonFieldsHeaders = {}
                    headers.forEach((x) => {
                        jsonFieldsHeaders[x.question] = x.question
                    });

                    this.jsonFieldsForFamilyMembers = {...this.jsonFieldsForFamilyMembers, ...jsonFieldsHeaders}
                }

                if(type === "Email" && !this.headersForEmail.find(val => val.value === questions[0].value)) {
                    const headers = questions.sort(function(a, b) {
                        return parseFloat(a.index) - parseFloat(b.index);
                    });
                    this.headersForEmail.push(...headers)

                    const jsonFieldsHeaders = {}
                    headers.forEach((x) => {
                        jsonFieldsHeaders[x.question] = x.question
                    });

                    this.jsonFieldsForEmail = {...this.jsonFieldsForEmail, ...jsonFieldsHeaders}
                }
            }

        },
        modify(data) {
            this.isSurveyModified = true;
            this.isDisabledSave = true;
        },
        getResidentsFamilyMember(response, person) {
            if(response?.isAnonymizeSurveyResult) {
                return "Anonymous";
            } else if(!response?.isAnonymizeSurveyResult && person.residents && person.residents.length) {
                return person.residents.map(x => x?.name).join(', ');
            } else {
              return "";
            }
        },
        toggleTooltip(event: MouseEvent) {
            if (!(event.target instanceof Element)) return;
            const paragraph = event.target.closest('.underline');
            if (!paragraph) return;

            const tooltip = paragraph.nextElementSibling;
            const isActive = tooltip.classList.contains('active');
            document.querySelectorAll('.tooltip-survey').forEach(el => el.classList.remove('active'));
            if (!isActive) {
                tooltip.classList.add('active');
            }
        },
        closeTooltip() {
            document.querySelectorAll('.tooltip-survey').forEach(el => el.classList.remove('active'));
        },
        initTooltips() {
            document.addEventListener('click', event => {
                if (!(event.target instanceof Element)) return;

                const isOutsideClick = !event.target.closest('.underline');

                if (isOutsideClick) {
                    document.querySelectorAll('.tooltip-survey').forEach(el => el.classList.remove('active'));
                }
            });
        },
        checkSurveyAudience() {
            this.audienceResidents = this.survey.audienceResidents ?? false;
            this.audienceFamily = this.survey.audienceFamily ?? false;
            this.audienceTriggered = this.survey.audienceTriggered ?? false;
            this.audienceEmail = this.survey.audienceEmail ?? false;
            this.selectedMailingList = this.survey.selectedMailingList ?? [];
            this.isAnonymizeSurvey = this.survey.isAnonymizeSurvey ?? false;
            this.isPreliminaryQuestions = this.survey.isPreliminaryQuestions ?? false;
        },
        checkMailingType(list) {
            switch (list.type) {
                case MailingTypes.Staff:
                    return this.facilityUsers?.length;
                case MailingTypes.Residents:
                    return this.residents?.length;
                case MailingTypes.Family:
                    return this.familyMembers.filter(x => !x.isUnsubscribedFromEmails)?.length;
                case MailingTypes.PendingFamilyMembers:
                    return this.familyMembers.filter(x => x.appStatus === FamilyHubAppStatus.Pending)?.length;
                case MailingTypes.ArchivedFamilyMembers:
                    return this.familyMembers.filter(x => (x.status === FamilyHubUserStatus.Archived || (x.residents || []).some(y => y.status === ResidentStatus.Departed)))?.length;
                case MailingTypes.FamilyWithFEPOA:
                    return this.familyMembers.filter(family => family?.financialEPOA?.some(epoa => epoa.status === true) == true)?.length;
                case MailingTypes.FamilyCanInviteOtherFamily:
                    return this.familyMembers.filter(family => family?.isCanInvite == true)?.length;
                case MailingTypes.FamilyMembersNotUsingTheApp:
                    return this.familyMembers.filter(family => !family?.invitedToFamilyApp)?.length;
                case MailingTypes.FamilyMembersWithTheAppActivated:
                    return this.familyMembers.filter(family => family.appStatus === FamilyHubAppStatus.Activated)?.length;
                case MailingTypes.FamilyMembersPerWing:
                    return this.familyMembersWithWings.filter((family) => family.wingId === list.wingId).length;
                case MailingTypes.FamilyMembersPerLevelOfCare:
                    return this.familyMembersPerLevelOfCare.filter((family) => family.careLevelIds.includes(list.careLevelId)).length;
                default:
                    return 0;
            }
        },
        checkSurveyTemplate(){
            if(this.audienceEmail === true && !this.surveyEmailTemplate?.html?.length){
                this.isMailingListDisabled = true
                this.selectedMailingList = null
                this.$toast.open({
                    type: "error",
                    message: "The enabled 'Survey Email' template does not contain any content",
                })
                console.error("The enabled 'Survey Email' template does not contain any content")
            }
            else{
                this.isMailingListDisabled = false
            }
        },
        onEmailSurveyChanged(){
            this.checkSurveyTemplate()
        },
        onMailingListChanged(){
            this.checkSurveyTemplate()
        }
    },
};
